import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Hero from "@/components/Hero";
import VideoSection from "@/components/VideoSection";
import Itinerary from "@/components/Itinerary";
import CountdownSection from "@/components/CountdownSection";
import VerseSection from "@/components/VerseSection";
import Gallery from "@/components/Gallery";
import IslandInfo from "@/components/IslandInfo";
import RSVPSection from "@/components/RSVPSection";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

function Home() {
  return (
    <main
      data-testid="home-page"
      className="overflow-x-hidden"
      onContextMenu={(e) => {
        // Block right-click everywhere except inside form inputs (so paste etc. still works).
        const tag = e.target?.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") return;
        e.preventDefault();
      }}
    >
      <Hero />
      <VideoSection />
      <Itinerary />
      <CountdownSection />
      <VerseSection />
      <Gallery />
      <IslandInfo />
      <RSVPSection />
      <Footer />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(10px)",
            border: "1px solid #E2DFD8",
            color: "#4A5346",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
